/* eslint-disable no-nested-ternary */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';

// Local stacked member cell for Screenshot Frequency: photo-or-initials avatar,
// name link on top, email below, truncated. Self-contained — does not touch any
// shared component or hook (mirrors the Webcam Audit / Geo member cell).
const AVATAR_PALETTE = [
  { bg: '#fdebe6', fg: '#b94f3c' },
  { bg: '#fde6d2', fg: '#F19235' },
  { bg: '#eef5ea', fg: '#53A551' },
  { bg: '#e8eef7', fg: '#4062E5' },
  { bg: '#f5e6f7', fg: '#9333ea' },
];

const pictureCache = new Map();

function avatarColors(key) {
  const str = String(key || '');
  let h = 0;
  // eslint-disable-next-line no-bitwise
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

function MemberCell({ id, firstName, lastName, email, profilePicture }) {
  const [photoUrl, setPhotoUrl] = useState(null);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    let mounted = true;
    setImgError(false);
    const resolve = async () => {
      const raw = `${profilePicture || ''}`.trim();
      if (!raw) { if (mounted) setPhotoUrl(null); return; }
      if (/^(https?:)?\/\//.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
        if (mounted) setPhotoUrl(raw); return;
      }
      if (!id) { if (mounted) setPhotoUrl(raw); return; }
      const key = `${id}:${raw}`;
      if (pictureCache.has(key)) { if (mounted) setPhotoUrl(pictureCache.get(key)); return; }
      const res = await sendRequest({ method: 'get', url: API.MEMBER.fileUrl(id), params: { fileName: raw } });
      if (res.success && res.data?.url) {
        pictureCache.set(key, res.data.url);
        if (mounted) setPhotoUrl(res.data.url); return;
      }
      if (mounted) setPhotoUrl(null);
    };
    resolve();
    return () => { mounted = false; };
  }, [profilePicture, id]);

  const fn = firstName || '';
  const ln = lastName || '';
  const em = email || '';
  const fullName = `${fn} ${ln}`.trim() || em || '—';
  const c = avatarColors(em || id);
  const initials = (fn && ln)
    ? `${fn[0]}${ln[0]}`.toUpperCase()
    : (em ? em.slice(0, 2).toUpperCase() : '?');

  return (
    <div className="flex items-center gap-3 min-w-0">
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden"
        style={{ backgroundColor: c.bg, color: c.fg, fontSize: 11, fontWeight: 600 }}
      >
        {photoUrl && !imgError ? (
          <img
            src={photoUrl}
            alt=""
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        ) : initials}
      </div>
      <div className="min-w-0">
        {id ? (
          <Link
            to={`/profile/${id}`}
            onClick={(e) => e.stopPropagation()}
            className="block text-ink-900 truncate hover:text-brand-700 hover:underline"
            style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px' }}
          >
            {fullName}
          </Link>
        ) : (
          <span className="block text-ink-900 truncate" style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>
            {fullName}
          </span>
        )}
        {em ? (
          <p className="text-ink-500 truncate" style={{ fontSize: 11, lineHeight: '16px', marginTop: 2 }}>
            {em}
          </p>
        ) : null}
      </div>
    </div>
  );
}

MemberCell.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  profilePicture: PropTypes.string,
};

MemberCell.defaultProps = {
  id: undefined,
  firstName: '',
  lastName: '',
  email: '',
  profilePicture: '',
};

export default MemberCell;
